import React from 'react';
import { AppContext, DocumentHomePage, DocPage } from '@component-controls/app';

const Layout = ({ docId, storyId, activeTab, category, type, docIndex, Link, Helmet, store, children, userData, }) => (React.createElement(AppContext, { Helmet: Helmet, docId: docId, storyId: storyId, type: type, store: store, linkClass: Link, activeTab: activeTab, userData: userData }, children ||
    (docIndex ? (React.createElement(DocumentHomePage, { type: type })) : (React.createElement(DocPage, { type: type, category: category })))));

export { Layout };
